/* rr-card — tocar una piedra en una tarjeta (24 oct 2026, Cesar: «al clicar sobre el swatch de
   variante, te muestra ahí mismo la variante sin tener que entrar»).
   Un solo escuchador para toda la página. El botón (snippet stone-swatches) dice su piedra
   (data-rr-swatch) y su variante (data-variant). La tarjeta trae las fotos de cada piedra en un
   <template data-rr-group> (snippet card-slides), que no se descarga hasta que se usa. Se cambian
   las fotos, el enlace pasa a ?variant= y queda marcado el cuadro. En la destacada de colección el
   cuadro va en su pie (.rr-slot) y manda sobre la tarjeta del mismo hueco. */
(() => {
  if (window.__rrCard) return;
  window.__rrCard = true;
  // compra rápida: el módulo solo se descarga al tocar el "+" (layout/theme.liquid le pasa la URL)
  const QUICK = document.currentScript && document.currentScript.dataset.quick;
  let quick;

  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-rr-quick]');
    if (plus && QUICK) {
      e.preventDefault();
      quick = quick || import(QUICK);
      quick.then((m) => m.open(plus)).catch(() => { location.href = plus.closest('.rr-card')?.querySelector('a')?.href || location.href; });
      return;
    }
    const btn = e.target.closest('[data-rr-swatch]');
    if (!btn) return;
    const scope = btn.closest('.rr-slot') || btn.closest('.rr-card');
    const card = btn.closest('.rr-card') || scope?.querySelector('.rr-card');
    if (!card) return;
    e.preventDefault();

    const value = btn.dataset.rrSwatch;
    const tpl = [...card.querySelectorAll('template[data-rr-group]')].find((t) => t.dataset.rrGroup === value);
    const track = card.querySelector('.rr-card__track');
    if (tpl && track) {
      const slides = tpl.content.cloneNode(true);
      const n = slides.querySelectorAll('.rr-card__slide').length;
      if (n) {
        track.replaceChildren(slides);
        track.scrollLeft = 0;
        const bar = card.querySelector('.rr-card__bar');
        if (bar) {
          bar.style.setProperty('--rr-slides', n);
          bar.hidden = n < 2;
        }
      }
    }

    const id = btn.dataset.variant;
    if (id) {
      for (const a of scope.querySelectorAll('a[href*="/products/"]')) {
        const u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('variant', id);
        a.setAttribute('href', u.pathname + u.search);
      }
    }
    for (const b of scope.querySelectorAll('[data-rr-swatch]')) {
      b.setAttribute('aria-pressed', b.dataset.rrSwatch === value ? 'true' : 'false');
    }
  });
})();
